import { render, staticRenderFns } from "./ProfilePasswordReset.vue?vue&type=template&id=95677100&scoped=true&"
import script from "./ProfilePasswordReset.vue?vue&type=script&lang=js&"
export * from "./ProfilePasswordReset.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePasswordReset.vue?vue&type=style&index=0&id=95677100&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95677100",
  null
  
)

export default component.exports